import { models } from 'powerbi-client';

export default ({
  type = 'report',
  tokenType = models.TokenType.Embed,
  accessToken,
  embedUrl,
  id,
  pageName,
  theme,
} = {}) => {
  const config = {
    type,
    tokenType,
    accessToken,
    embedUrl,
    id,
    settings: {
      panes: {
        pageNavigation: {
          visible: false,
        },
        filters: {
          visible: false,
        },
      },
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.FitToPage,
      },
    },
    theme,
  };
  if (pageName) config.pageName = pageName;
  return config;
};
